import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { BuildingFilterActvityComponent } from './building-filter-actvity.component';
import { BuildingActivityDetailComponent } from './building-activity-detail/building-activity-detail.component';
import { UserTypeComponent } from './user-type/user-type.component';
import { BuildingActivityTypeComponent } from './building-activity-type/building-activity-type.component';
import { AccessPointFilterActvityModule } from '../access-point-filter-actvity/access-point-filter-actvity.module';
import { WithTooltipModule } from '../../with-tooltip/with-tooltip.module';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [
    BuildingFilterActvityComponent,
    BuildingActivityDetailComponent,
    UserTypeComponent,
    BuildingActivityTypeComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    WithTooltipModule,
    TranslateModule,
    // reuse the Date Range (calendar) screen from the access-point filter
    AccessPointFilterActvityModule,
  ],
  exports: [BuildingFilterActvityComponent],
  providers: [LocalizationService, TranslateModule],
})
export class BuildingFilterActvityModule {}
